import React, {memo, useMemo} from "react"
import {SettingsPageContainer} from "../../../../components/Settings/SettingsPageContainer"
import {PasswordContainer} from "../../../../components/PasswordContainer"
import {SubMenuComponent} from "../../../../components/SubMenu"
import {useLocalization} from "../../../../hooks/localization"
import iconCustomization from "../../../../assets/images/icons/settings/customization.png"
import iconScreen from "../../../../assets/images/icons/screen-menu.png"
import iconTheme from "../../../../assets/images/icons/theme.png"
import iconCleanPanel from "../../../../assets/images/icons/settings/ino-pan-clean.png"
import iconControls from "../../../../assets/images/icons/settings/sensors.png"
import iconSensors from "../../../../assets/images/icons/settings/controls.png"
import iconMainPage from "../../../../assets/images/icons/settings/main-page.png"

import "./index.scss"
import { hasAuthority } from "../../../../utils/role"
import { useSelector } from "react-redux";
import { UserRole } from "../../../../types/control"

export const CustomMenu = memo(function CustomMenu() {
    const {t} = useLocalization();
    const currentRole = useSelector(state => state.ui.role)
    const subPages = useMemo(
        () => [
            {
                icon: iconCustomization,
                name: t("customizations.wallpaper"),
                requiredRole: "default",
                path: "/settings/custom-menu/customization"
            },
            {
                icon: iconScreen,
                name: t("screen"),
                requiredRole: "default",
                path: "/settings/custom-menu/screen-set/1"
            },
            {
                icon: iconTheme,
                name: t("customizations.theme"),
                requiredRole: "default",
                path: "/settings/custom-menu/icon-theme"
            },
            {
                icon: iconCleanPanel,
                name: t("screen_clean_mode"),
                requiredRole: "default",
                path: "/settings/custom-menu/screen-cleaner"
            },
            {
                icon: iconControls,
                name: t("control_sorting"),
                requiredRole: "admin",
                path: "/settings/custom-menu/sorting-menu/controls"
            },
            {
                icon: iconSensors,
                name: t("sensor_sorting"),
                requiredRole: "admin",
                path: "/settings/custom-menu/sorting-menu/sensors"
            },
            {
                icon: iconMainPage,
                name: t("home_page_2"),
                requiredRole: "admin",
                path: "/settings/custom-menu/sorting-menu/homepage"
            },
            {
                icon: iconMainPage,
                name: t("left_menu"),
                requiredRole: "admin",
                path: "/settings/custom-menu/sorting-menu/left-menu"
            }
        ].filter((page) => hasAuthority(currentRole as UserRole, page.requiredRole as UserRole)),
        [t, currentRole]
    )
    return (
        <PasswordContainer requiredRole="default" isFullscreen={true}>
            <SettingsPageContainer buttons={[]} className="service-edit" backUrl={"/settings"} style={null}>
                <div className="content-divider">
                    <div className="sub-menu-content-divider">
                      {subPages.map((control, index) => (
                        <SubMenuComponent key={index} icon={control.icon} name={control.name} path={control.path} />
                      ))}
                    </div>
                </div>
            </SettingsPageContainer>
        </PasswordContainer>
    )
})
